// authTypes.js — DealCouponz-style action constants (subset for CouponDealz)

export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";

export const REGISTER_REQUEST = "REGISTER_REQUEST";
export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_FAILURE = "REGISTER_FAILURE";

export const RESTORE_REQUEST = "RESTORE_REQUEST";
export const RESTORE_SUCCESS = "RESTORE_SUCCESS";
export const RESTORE_FAILURE = "RESTORE_FAILURE";

export const LOGOUT = "LOGOUT";
